import {
    CLEAR_PAGE_SEARCH_FILTER,
    FETCHED_PAGES,
    PAGE_SEARCH_BY_TITLE
} from './types';

export function fetchedPages(pages) {
    return {
        type: FETCHED_PAGES,
        pages
    }
}

export function clearPageSearchFilter() {
    return {
        type: CLEAR_PAGE_SEARCH_FILTER,
    }
}

export function searchByTitle(searchBy) {
    return {
        type: PAGE_SEARCH_BY_TITLE,
        payload: searchBy
    }
}


// WEBPACK FOOTER //
// ./src/containers/page-picker/actions.js